import { render, staticRenderFns } from "./AppealsForm.vue?vue&type=template&id=3b08bd3a&scoped=true"
import script from "./AppealsForm.vue?vue&type=script&lang=js"
export * from "./AppealsForm.vue?vue&type=script&lang=js"
import style0 from "./AppealsForm.vue?vue&type=style&index=0&id=3b08bd3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b08bd3a",
  null
  
)

export default component.exports